import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { name: "首页", to: "/" },
  { name: "热议焦点", to: "/topics" },
  { name: "舆论风向", to: "/topics?cat=culture" },
  { name: "关于我们", to: "/about" },
  { name: "常见问题", to: "/faq" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  const onSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = query.trim();
    navigate(q ? `/topics?q=${encodeURIComponent(q)}` : "/topics");
    setOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/70 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between gap-4 px-4 md:h-20 md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2.5" aria-label="天涯吃瓜首页">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-white">
            <i className="ri-eye-fill text-xl" aria-hidden="true"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-900">
              天涯吃瓜
            </span>
            <span className="mt-1 hidden text-[11px] font-medium text-foreground-400 sm:block">
              热议焦点 · 舆论风向观察
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `rounded-md px-3.5 py-2 text-sm font-medium whitespace-nowrap transition-colors hover:text-primary-600 ${
                  isActive ? "text-primary-600" : "text-foreground-700"
                }`
              }
            >
              {item.name}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <form onSubmit={onSearch} className="relative">
            <i
              className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400"
              aria-hidden="true"
            ></i>
            <input
              type="search"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="搜索热议话题…"
              aria-label="搜索热议话题"
              className="h-9 w-40 rounded-full border border-background-200 bg-white pl-9 pr-3 text-sm text-foreground-800 outline-none transition focus:border-primary-400 focus:ring-2 focus:ring-primary-100 lg:w-52"
            />
          </form>
          <Link
            to="/topics"
            className="inline-flex h-9 items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 text-sm font-medium text-white transition-colors hover:bg-primary-600"
          >
            <i className="ri-fire-line text-base" aria-hidden="true"></i>
            围观热榜
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="切换菜单"
          aria-expanded={open}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 lg:hidden"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} aria-hidden="true"></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <nav className="flex flex-col" aria-label="移动端导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2.5 text-sm font-medium ${
                    isActive ? "text-primary-600" : "text-foreground-700"
                  }`
                }
              >
                {item.name}
              </NavLink>
            ))}
            <form onSubmit={onSearch} className="mt-2 flex items-center gap-2 px-3">
              <div className="relative flex-1">
                <i
                  className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400"
                  aria-hidden="true"
                ></i>
                <input
                  type="search"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  placeholder="搜索热议话题…"
                  aria-label="搜索热议话题"
                  className="h-9 w-full rounded-full border border-background-200 bg-white pl-9 pr-3 text-sm text-foreground-800 outline-none focus:border-primary-400"
                />
              </div>
              <button
                type="submit"
                className="h-9 rounded-full bg-primary-500 px-4 text-sm font-medium text-white"
              >
                搜索
              </button>
            </form>
          </nav>
        </div>
      )}
    </header>
  );
}